/** Tiny in-process event bus — mirrors mobile utils/events.ts. */

type Listener = (...args: unknown[]) => void

class AppEventEmitter {
  private listeners: Record<string, Listener[]> = {}

  on(event: string, fn: Listener): () => void {
    if (!this.listeners[event]) this.listeners[event] = []
    this.listeners[event].push(fn)
    return () => {
      this.listeners[event] = (this.listeners[event] || []).filter((l) => l !== fn)
    }
  }

  emit(event: string, ...args: unknown[]) {
    this.listeners[event]?.forEach((fn) => fn(...args))
  }
}

export const appEvents = new AppEventEmitter()

/** Fired after any weight-history write so the per-day targets cache reloads (4.34). */
export const WEIGHT_HISTORY_CHANGED = 'weightHistory:changed'
